// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"496":"2045d800","4782":"4cce3201"}[chunkId] || chunkId) + "." + {"496":"c1f9ec964179f4d1","3190":"7c93e6392fdb7dfd","4782":"733e664ebcaba533"}[chunkId] + ".js";
};